import { type Invoice, request, type User } from '@/shared'

export const getInvoicePortal = (id: string) => request<Invoice>('get', `/portal/invoice/${id}`)
export const getUserPortal = (id: string) => request<User>('get', `/portal/user/${id}`)
export const getInvoicePdfUrl = (id: string) => request<string>('get', `/portal/invoice-pdf/${id}`)
